import useObserver from '../../hooks/page/useObserver';
import PageTemplate from '../../components/ui/PageTemplate';

const Partners = () => {
  useObserver(
    'content-Partners',
    'content-Partners-tablet',
    'content-Partners-desktop'
  );

  return (
    <PageTemplate id='Partners'>
      {/* Mobile Layout */}
      <div
        id='content-Partners'
        className='md:hidden w-full py-20 flex flex-col gap-10 max-w-[360px] mx-auto'
      >
        <div className='flex flex-col justify-start items-start w-full px-4'>
          <h1 className='text-xl font-semibold text-[#FFFFFF]'>Partners</h1>
        </div>
        <div className='w-full flex flex-col gap-10 px-4'>
          {/* Partners in Progress */}
          <div className='flex flex-col gap-4'>
            <p className='text-base font-semibold text-[#FFFFFF]'>
              Partners in Progress
            </p>
            <div className='flex flex-col gap-4'>
              <div className='flex flex-row gap-4 items-start justify-between'>
                <div className='flex-1 flex flex-col'>
                  <p className='text-2xl font-semibold text-[#FFFFFF]'>
                    SDA TAP LAB
                  </p>
                  <div className='flex flex-col'>
                    <p className='text-sm font-semibold text-[#FFFFFF]'>
                      Apollo Accelerator
                    </p>
                    <p className='text-sm font-semibold text-[#FFFFFF]'>
                      (US Space Force)
                    </p>
                  </div>
                </div>
                <div className='w-[156px] h-[95.73px] pt-2 pr-4 pb-2 pl-4 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                  <img
                    src='/img/SDA-TAP-LAB.png'
                    alt='SDA TAP LAB'
                    className='w-full h-full object-contain'
                  />
                </div>
              </div>
              <div className='flex flex-col w-full'>
                <div className='h-px w-full bg-[#FFFFFF40] mb-2' />
                <div className='flex flex-row items-start gap-2'>
                  <span className='w-1 h-1 rounded-full bg-white self-start mt-2' />
                  <p className='text-white text-sm'>
                    Participation completed in Cohort 4~8 (Aug 2024 - Nov 2025)
                  </p>
                </div>
                <div className='h-px w-full bg-[#FFFFFF40] my-2' />
                <div className='flex flex-row items-start gap-2'>
                  <span className='w-1 h-1 rounded-full bg-white self-start mt-2' />
                  <p className='text-white text-sm'>
                    Awarded to Cohort 4 and 6 (Oct 2024, Apr 2025)
                  </p>
                </div>
                <div className='h-px w-full bg-[#FFFFFF40] mt-2' />
              </div>
            </div>
          </div>
          {/* Investor */}
          <div className='flex flex-col gap-4'>
            <p className='text-base font-semibold text-[#C6C6C6]'>Investor</p>
            <div className='grid grid-cols-2 gap-2'>
              <div className='w-[160px] h-[72.55px] py-1 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/Enlight-Ventures.png'
                  alt='Enlight Ventures'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[160px] h-[72.55px] py-1 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/The-Invention-Lab.png'
                  alt='The Invention Lab'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[160px] h-[72.55px] py-1 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/HRSB.png'
                  alt='HRSB'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[160px] h-[72.55px] py-1 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/EcoPro.png'
                  alt='EcoPro'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[160px] h-[72.55px] py-1 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/KODIT.png'
                  alt='KODIT'
                  className='w-full h-full object-contain'
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tablet Layout */}
      <div
        id='content-Partners-tablet'
        className='hidden md:flex xl:hidden w-full md:max-w-[688px] mx-auto flex-col py-[140px] gap-[100px] overflow-hidden'
      >
        <div className='flex flex-col justify-start items-start w-full'>
          <h1 className='text-3xl font-semibold text-[#FFFFFF]'>Partners</h1>
        </div>
        <div className='w-full flex flex-col gap-20'>
          {/* Partners in Progress */}
          <div className='flex flex-col gap-4'>
            <p className='md:text-[20px] font-semibold text-[#FFFFFF]'>
              Partners in Progress
            </p>
            <div className='w-full flex flex-col gap-6'>
              <div className='w-full flex flex-row gap-6'>
                <div className='flex-1 flex flex-col'>
                  <p className='text-[40px] font-semibold text-[#FFFFFF]'>
                    SDA TAP LAB
                  </p>
                  <div className='flex flex-col'>
                    <p className='text-[26px] font-medium text-[#FFFFFF]'>
                      Apollo Accelerator
                    </p>
                    <p className='text-[26px] font-medium text-[#FFFFFF]'>
                      (US Space Force)
                    </p>
                  </div>
                </div>
                <div className='w-[224.01px] h-[140px] pt-[18px] pr-[32px] pb-[18px] pl-[32px] rounded-[8px] bg-[#FFFFFF] flex items-center justify-center'>
                  <img
                    src='/img/SDA-TAP-LAB.png'
                    alt='SDA TAP LAB'
                    className='w-full h-full object-contain'
                  />
                </div>
              </div>
              <div className='flex flex-col w-full'>
                <div className='h-px w-full bg-[#FFFFFF40] mb-2' />
                <div className='flex flex-row items-center gap-2'>
                  <span className='w-1 h-1 rounded-full bg-white' />
                  <p className='text-white text-base'>
                    Participation completed in Cohort 4~8 (Aug 2024 - Nov 2025)
                  </p>
                </div>
                <div className='h-px w-full bg-[#FFFFFF40] my-2' />
                <div className='flex flex-row items-center gap-2'>
                  <span className='w-1 h-1 rounded-full bg-white' />
                  <p className='text-white text-base'>
                    Awarded to Cohort 4 and 6 (Oct 2024, Apr 2025)
                  </p>
                </div>
                <div className='h-px w-full bg-[#FFFFFF40] mt-2' />
              </div>
            </div>
          </div>
          {/* Investor */}
          <div id='Logos' className='flex flex-col gap-4'>
            <p className='text-xl font-semibold text-[#C6C6C6]'>Investor</p>
            <div className='w-full flex flex-row gap-2'>
              <div className='w-[132px] h-[60px] p-2 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/Enlight-Ventures.png'
                  alt='Enlight Ventures'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[132px] h-[60px] p-2 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/The-Invention-Lab.png'
                  alt='The Invention Lab'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[132px] h-[60px] p-2 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/HRSB.png'
                  alt='HRSB'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[132px] h-[60px] p-2 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/EcoPro.png'
                  alt='EcoPro'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[132px] h-[60px] p-2 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/KODIT.png'
                  alt='KODIT'
                  className='w-full h-full object-contain'
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div
        id='content-Partners-desktop'
        className='hidden xl:flex w-full xl:max-w-[1060px] mx-auto flex-col py-[140px] gap-[100px] overflow-hidden'
      >
        <div className='flex flex-col justify-start items-start w-full'>
          <h1 className='text-3xl font-semibold text-[#FFFFFF]'>Partners</h1>
        </div>
        <div className='w-full flex flex-col gap-14'>
          {/* Partners in Progress */}
          <div className='flex flex-col gap-4'>
            <p className='text-xl font-semibold text-[#C6C6C6]'>
              Partners in Progress
            </p>
            <div className='w-full flex flex-row gap-6'>
              <div className='w-[764px] flex flex-col gap-10'>
                <div className='flex flex-col'>
                  <p className='text-[40px] font-semibold text-[#FFFFFF]'>
                    SDA TAP LAB
                  </p>
                  <p className='text-[26px] font-medium text-[#FFFFFF]'>
                    Apollo Accelerator (US Space Force)
                  </p>
                </div>
                <div className='flex flex-col w-full'>
                  <div className='h-px w-full bg-[#FFFFFF40] mb-2' />
                  <div className='flex flex-row items-center gap-2'>
                    <span className='w-1 h-1 rounded-full bg-white' />
                    <p className='text-white text-base'>
                      Participation completed in Cohort 4~8 (Aug 2024 - Nov
                      2025)
                    </p>
                  </div>
                  <div className='h-px w-full bg-[#FFFFFF40] my-2' />
                  <div className='flex flex-row items-center gap-2'>
                    <span className='w-1 h-1 rounded-full bg-white' />
                    <p className='text-white text-base'>
                      Awarded to Cohort 4 and 6 (Oct 2024, Apr 2025)
                    </p>
                  </div>
                  <div className='h-px w-full bg-[#FFFFFF40] mt-2' />
                </div>
              </div>
              <div className='pt-[18px] pr-[32px] pb-[18px] pl-[32px] rounded-[8px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/SDA-TAP-LAB.png'
                  alt='SDA TAP LAB'
                  className='w-full h-full object-contain'
                />
              </div>
            </div>
          </div>
          {/* Investor */}
          <div className='flex flex-col gap-4'>
            <p className='text-xl font-semibold text-[#C6C6C6]'>Investor</p>
            <div className='w-full flex flex-row gap-2'>
              <div className='w-[205.6px] h-[93.23px] p-2 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/Enlight-Ventures.png'
                  alt='Enlight Ventures'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[205.6px] h-[93.23px] p-2 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/The-Invention-Lab.png'
                  alt='The Invention Lab'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[205.6px] h-[93.23px] p-2 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/HRSB.png'
                  alt='HRSB'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[205.6px] h-[93.23px] p-2 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/EcoPro.png'
                  alt='EcoPro'
                  className='w-full h-full object-contain'
                />
              </div>
              <div className='w-[205.6px] h-[93.23px] p-2 rounded-[4px] bg-[#FFFFFF] flex items-center justify-center'>
                <img
                  src='/img/KODIT.png'
                  alt='KODIT'
                  className='w-full h-full object-contain'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Partners;
